<template>
  <div>
    <section>
      <b-row>
        <b-col cols="12" md="4"
          ><b-form-input
            v-model="searchValue"
            @input="onSearch"
            placeholder="search..."
          ></b-form-input
        ></b-col>
        <b-col cols="6" md="6">
          <b-form-radio-group
            id="radio-group-1"
            @input="onSearch"
            v-model="selectedEventType"
            :options="optionsEventTypes"
            name="radio-options"
          ></b-form-radio-group>
        </b-col>
        <b-col v-if="is_add" cols="6" md="2">
          <b-button block @click="onAddVoucher" variant="primary"
            >Add Voucher</b-button
          >
        </b-col>
      </b-row>
    </section>
    <b-card no-body header-tag="header" footer-tag="footer">
      <b-card-text>
        <b-table
          bordered
          responsive
          :fields="fields"
          :items="items"
          :busy="isBusy"
          outlined
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(sr)="data">
            {{
              data.index + 1 + (pagination.currentPage - 1) * pagination.limit
            }}
          </template>

          <template #cell(voucher_is_active)="data">
            {{ data.item.voucher_is_active == "Y" ? "Active" : "Disabled" }}
          </template>

          <template v-if="is_update" #cell(action)="data">
            <b-button
              @click="onEditItem(data.item)"
              size="sm"
              variant="outline-primary"
              >Edit</b-button
            >
          </template>
        </b-table>
      </b-card-text>
      <template #footer>
        <div>
          <b-row>
            <b-col
              class="d-flex align-items-end justify-content-end justify-content-sm-center"
            >
              <b-pagination
                v-model="pagination.currentPage"
                :total-rows="pagination.totalRows"
                :per-page="pagination.limit"
                @change="onChange"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import { GetVoucherListService } from "@/apiServices/MasterServices";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { UserService } from "@/apiServices/storageService";
export default {
  data() {
    return {
      searchValue: null,

      isBusy: false,
      fields: [
        {
          key: "sr",
          label: "SR",
        },
        {
          key: "event_name",
          label: "Event Name",
          sortable: true,
        },
        {
          key: "voucher_code",
          label: "voucher code",
          sortable: true,
        },
        {
          key: "min_seats_required",
          label: "Min Seats Limit",
          sortable: true,
        },
        {
          key: "max_seats_required",
          label: "Max Seat Limit",
          sortable: true,
        },
        {
          key: "max_transaction_per_user",
          label: "Max Transaction/User",
          sortable: true,
        },
        {
          key: "total_available_voucher",
          label: "Total Vouchers",
          sortable: true,
        },
        {
          key: "discount_type",
          label: "Discount Type",
          sortable: true,
        },
        {
          key: "voucher_discount_value",
          label: "Discount Value",
          sortable: true,
        },

        {
          key: "voucher_is_active",
          label: "Voucher Status",
          sortable: true,
        },
        {
          key: "action",
          label: "",
        },
      ],
      items: [],
      pagination: {
        currentPage: 1,
        limit: 10,
        totalRows: 0,
      },
      debounce: null,
      selectedEventType: "Y",
      optionsEventTypes: [
        { text: "Active Events", value: "Y" },
        { text: "Disabled Events", value: "N" },
        { text: "All Events", value: "" },
      ],
    };
  },
  computed: {
    is_add() {
      let permissionData = UserService.getUserPermissions();
      let obj = permissionData.find((o) => o.subject == this.$route.name);
      if (obj) {
        let objP = obj.permission.find((p) => p == "create");
        if (objP) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    is_update() {
      let permissionData = UserService.getUserPermissions();
      let obj = permissionData.find((o) => o.subject == this.$route.name);
      if (obj) {
        let objP = obj.permission.find((p) => p == "update");
        if (objP) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    is_read() {
      let permissionData = UserService.getUserPermissions();
      let obj = permissionData.find((o) => o.subject == this.$route.name);
      if (obj) {
        let objP = obj.permission.find((p) => p == "read");
        if (objP) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  beforeMount() {
    this.getVoucherList();
  },
  methods: {
    async onAddVoucher() {
      this.$router.push({
        name: "voucherform",
      });
    },
    async onSearch() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getVoucherList();
      }, 1000);
    },
    async onEditItem(item) {
      this.$router.push({
        name: "voucherform",
        query: { voucher_id: item.voucher_id },
      });
    },
    async getVoucherList() {
      try {
        this.isBusy = true;
        const response = await GetVoucherListService({
          limit: this.pagination.limit,
          currentPage: this.pagination.currentPage,
          search: this.searchValue,
          selectedEventType: this.selectedEventType,
        });
        if (response.data.status) {
          this.items = response.data.Records.data;
          if (!isNaN(response.data.Records.pagination.total)) {
            this.pagination.totalRows = response.data.Records.pagination.total;
          }
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        console.log(error);
      }
    },

    onChange() {
      this.$nextTick(() => {
        this.getVoucherList();
      });
    },
  },
};
</script>
